
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { _postURL } from '@/api/index';
import _ from 'lodash';
import { DealerFilter } from '../../components/dealer/filter';
import { DealerDetail } from '../../components/dealer/detail';
import { countryState } from '../../config/site';

export default function Index(props) {
    const { t, device, session, params, fetchedData } = props;

    if( // search brand, state
        params?.id?.length === 2
        && !(params?.id?.[0] > 0) // is not more then 0
        && params?.id?.[1].startsWith('state')
    ){
        return <DealerFilter  {...props} />
    } else if( // search by id
        params?.id?.length === 1
        && params?.id?.[0] > 0
        && !_.isEmpty(fetchedData)
    ){
        return <DealerDetail {...props} />
    } else if( // search by brand or search by state
        params?.id?.length === 1
        && !(params?.id?.[0] > 0)
    ){
        return <DealerFilter  {...props} />
    } else {
        return <>404 page</>
    }
}

export async function getServerSideProps ({ req, res, locale, params, query }) {
    
    try {
        let fetchedData = null;
        if(
            params?.id?.length === 2
            && !(params?.id?.[0] > 0) // is not more then 0
            && !(params?.id?.[0].startsWith('state')) // is not start text with state
            && params?.id?.[1].startsWith('state') // start text must have state
        ){
            // search brand, state
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getAllVehicleBrandList`, {})
            ]);
            fetchedData = data ?? {}

            // go 404 if no have correct value
            if(!(fetchedData.some(item => item.brand_custom_url === params?.id?.[0]))) throw new Error();
            if(!(countryState.some(item => item.value === params?.id?.[1]))) throw new Error();

        } else if (
            params?.id?.length === 1
            && params?.id?.[0] > 0 // is more then 0
        ){ // search by id
            
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/dealer/getOneDealer`, { link: params?.id?.[0] })
            ]);
            fetchedData = data ?? {}
        } else if (
            params?.id?.length === 1
            && !(params?.id?.[0] > 0) // is more then 0
        ){ // search by brand or seach by state
            const [{ value: { data } }] = await Promise.allSettled([
                _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/vehicle/getAllVehicleBrandList`, {})
            ]);
            fetchedData = data ?? {}

            if(params?.id?.[0].startsWith('state')){
                // go 404 if no have correct value
                if(!(countryState.some(item => item.value === params?.id?.[0]))) throw new Error();
            } else {
                // go 404 if no have correct value
                if(!(fetchedData.some(item => item.brand_custom_url === params?.id?.[0]))) throw new Error();
            }
        } else {
            throw new Error();
        }

        if (_.isEmpty(fetchedData)) throw new Error();

        return {
            props: {
                ...(await serverSideTranslations(locale, ['common'])),
                fetchedData,
                params,
                query
            },
        };
    } catch (error) {
        return {
            notFound: true,
        }
    }
}